import type { InitialDataType } from '@/utils/hooks/context/dashboardCustomization/contextConfig';

import {
    LAYOUT_COVER_IMAGE_CENTER,
    LAYOUT_COVER_IMAGE_LEFT
} from '@/lib/dashboard/dashboardCustomization/layoutOptions';

export function checkValidDashboardCustomization(customization: InitialDataType) {
    if (!customization) {
        return false;
    } else if (
        customization &&
        (!customization?.cover_page?.content?.cover ||
            !customization?.cover_page?.content?.cover?.min_thumbnail_url) &&
        (customization?.cover_page?.content?.layout === LAYOUT_COVER_IMAGE_CENTER ||
            customization?.cover_page?.content?.layout === LAYOUT_COVER_IMAGE_LEFT)
    ) {
        return false;
    }

    return true;
}
